import { Fragment, ReactElement } from 'react'

export const removeFragmentFromChildren = (children: ReactElement) => {
  const childs =
    children?.type === Fragment ? children?.props?.children : children

  return childs
}
